<template>
  <vinnuskoli-page>
    <b-row class="mb-3">
      <b-col>
        <div class="page-title mb-0">Launakerfi</div>
      </b-col>
    </b-row>

    <b-tabs v-model="tabIndex">
      <b-tab title="Launamenn" lazy>
        <payroll-payment-persons />
      </b-tab>
      <b-tab title="Starfsmenn" lazy>
        <payroll-employees />
      </b-tab>
      <b-tab title="Kjarni" v-if="loggedInUser.town.hasKjarni" lazy>
        <payroll-employees-kjarni />
      </b-tab>
      <b-tab title="H3" v-if="loggedInUser.town.hasH3" lazy>
        <payroll-h3 />
      </b-tab>
    </b-tabs>
  </vinnuskoli-page>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PayrollPaymentPersons from '../components/payroll/PayrollPaymentPersons.vue';
import PayrollEmployees from '../components/payroll/PayrollEmployees.vue';
import PayrollEmployeesKjarni from '../components/payroll/PayrollEmployeesKjarni.vue';
import PayrollH3 from '../components/payroll/PayrollH3.vue';

export default {
  name: 'payroll',
  components: {
    PayrollPaymentPersons,
    PayrollEmployees,
    PayrollEmployeesKjarni,
    PayrollH3,
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  computed: {
    ...mapGetters(['loggedInUserHasAnyPermission']),
    ...mapState({
      loggedInUser: 'loggedInUser',
    }),
  },
  methods: {
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
};
</script>

<style></style>
